export default {
  controlinetpays: {
    title: "Контроль за надходженням інтернет-платежів",
    displayPayment: {
      title: "Відображати оплати",
      payAll: "Все",
      payMoneyReceived: "За яким надійшли гроші",
      payMoneyNotReceived: "За яким не надійшли гроші",
      payPersonalAccounts: "Відображати оплати по особових рахунках"
    },
    reportingMonthColumn: {
      headers: {
        reportingMonth: "Звітний місяць"
      }
    },
    paymentSenderColumn: {
      headers: {
        paymentSender: "Відправник платежу"
      }
    },
    inetPayNotConnectedPaymentsColumn: {
      headers: {
        inetPayNotConnectedPayments: "Інтернет-оплати, не пов'язані з платежами"
      }
    },
    personalAccountsPaymentsColumn: {
      headers: {
        abcodeLong: "Особовий рахунок",
        payment: "Оплата",
        registry: "Реєстр"
      }
    },
    moveToNextMonth: {
      confirm: {
        transferPaymentsFrom: "Перенести оплати від",
        for: "за",
        on: "на",
        title: "Перенесення на наступний місяць"
      }
    },
    cancelReceivedRegistry: {
      confirm: {
        сancelRegistry: "Скасувати реєстр",
        from: "від",
        behind: "за",
        title: "Скасування отриманого реєстру"
      }
    },
    cancelSubscriberPayment: {
      confirm: {
        сancelSubscriberPayment: "Скасувати оплату абонента",
        behind: "за",
        on: "на",
        title: "Скасування оплати абонента"
      }
    }
  }
};
